// PRAT-102: chat loja x cliente durante o pedido (pratigo-chat-worker).
// {{domain}}/api/app/orders/{{orderId}}/chat-token
export const ENDPOINT = 'api/app/orders';

export type ChatRole = 'loja' | 'cliente';

export type OrderChatTokenResponse =
  | { enabled: false; message?: string }
  | {
      enabled: true;
      order_id: string;
      role: ChatRole;
      socket_url: string;
      token: string;
      expires_at: number;
    };

export interface ChatMessage {
  id: number;
  /** "sistema" = andamento do pedido (aceito, saiu para entrega...) enviado pela API. */
  role: ChatRole | 'sistema';
  name: string;
  text: string;
  at: number;
  client_id?: string;
  status_id?: number;
}

export interface ChatPresence {
  loja: number;
  cliente: number;
}

export type ChatServerEvent =
  | {
      type: 'hello';
      order_id: string;
      role: ChatRole;
      messages: ChatMessage[];
      presence: ChatPresence;
    }
  | { type: 'message'; message: ChatMessage }
  | { type: 'presence'; presence: ChatPresence }
  | { type: 'read'; role: ChatRole; up_to: number }
  | { type: 'closed'; reason: string }
  | { type: 'error'; code: string; message: string; client_id?: string };

/** Códigos de fechamento do Worker. */
export const CHAT_CLOSE = { UNAUTHORIZED: 4401, FORBIDDEN: 4403, ROOM_CLOSED: 4410 } as const;

export const CHAT_MAX_LENGTH = 1000;
